export class JuridicaGeneral {
    constructor({ tipoFrmEmpresa } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            tipo_juridico: {
                value: null,
                header: 'Tipo de Persona Juridica:',
                required: 'Tipo de Persona Juridica es requerido',
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            pais: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            fecha: {
                value: new Date(),
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
            },
            nuevo_accionista: {
                value: null,
                header: '¿Es nuevo accionista:',
                required: 'Seleccione una opción'
            },
            provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerida'
            },
            compania: {
                value: '',
                header: 'Compañía:',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Companía es requerida',
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            grupo_empresarial: {
                value: null,
                header: 'Agrupa para grupo empresarial:',
                required: 'Es requerida',
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            tipo_formulario: {
                value: null,
                header: 'Tipo de formulario:',
                required: 'Tipo de formulario es requerido'
            },
            razon_social: {
                value: '',
                header: 'Razón social',
                headerPorTipo: {
                    FRM_TOYOTA: 'Razón Social:',
                    FRM_DIFARE: 'Razón Social / Nombre:',
                },
                required: 'Razón Social es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4,
            },
            identificacion: {
                value: '',
                header: 'No. RUC / Identificación tributaria:',
                required: 'No. RUC / Identificación tributaria es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            nacionalidad: {
                value: null,
                header: 'Nacionalidad',
                headerPorTipo: {
                    FRM_TOYOTA: 'Nacionalidad:',
                    FRM_DIFARE: 'Nacionalidad:',
                },
                required: 'Nacionalidad es requerida'
            },
            fecha_inicio_actividad: {
                value: null,
                header: 'Fecha inicio de actividades (día/mes/año):',
                headerPorTipo: {
                    FRM_TOYOTA: 'Fecha de inicio de actividades:',
                    FRM_DIFARE: 'Fecha de inicio de actividades:',
                },
                required: 'Fecha inicio de actividad es requerido'
            },
            actividad_economica: {
                value: null,
                header: 'Actividad Económica',
                required: 'Actividad económica es requerido'
            },
            direccion_oficina: {
                value: '',
                header: 'Dirección',
                headerPorTipo: {
                    FRM_TOYOTA: 'Dirección oficina:',
                    FRM_DIFARE: 'Dirección oficina:',
                },
                required: 'Dirección domicilio es requerido',
                maxLength: 'Máximo 1000 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 1000,
                min: 4
            },
            pais_datos_generales: {
                value: null,
                header: 'País:',
                required: 'País es requerido',
            },
            provincia_datos_generales: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad_datos_generales: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerido'
            },
            canton_datos_generales: {
                value: '',
                header: 'Ciudad',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerido'
            },
            codigo_postal: {
                value: '',
                header: 'Apartado postal (en el caso de ser extranjero)',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Apartado postal es requerido'
            },
            telefono_empresa: {
                value: '',
                header: 'Teléfono de empresa',
                headerPorTipo: {
                    FRM_TOYOTA: 'Teléfono empresa:',
                    FRM_DIFARE: 'Teléfono empresa:',
                },
                required: 'Teléfono de empresa es requerido',
                maxLength: 'Máximo 30 caracteres',
                minLength: 'Mínimo 7 caracteres',
                max: 30,
                min: 7,
            },
            pagina_web_email: {
                value: '',
                header: 'Página web o dirección electrónica de la empresa:',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Página Web o correo electrónico es requerido'
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
}
